import React from "react";
import { euro } from "@/lib/format";
import { Checkbox } from "@/components/ui/checkbox";
import { Label } from "@/components/ui/label";
import { UtensilsCrossed, Moon } from "lucide-react";

export function RimborsiOre({ pasto, onPasto, cena, onCena, impostazioni, testid }) {
  return (
    <div className="space-y-1.5" data-testid={`${testid}-rimborsi`}>
      <Label>Rimborsi</Label>
      <div className="flex flex-wrap gap-2">
        <label className={`flex items-center gap-2 rounded-lg border px-3 h-10 cursor-pointer text-sm select-none transition-colors ${pasto ? "border-amber-300 bg-amber-50 text-amber-800" : "border-slate-200 text-slate-600 hover:bg-slate-50"}`}>
          <Checkbox checked={pasto} onCheckedChange={(v) => onPasto(!!v)} data-testid={`${testid}-pasto-cantiere`} />
          <UtensilsCrossed className="h-4 w-4" /> Pasto cantiere <span className="font-mono text-xs opacity-70">{euro(impostazioni?.rimborso_pranzo_cantiere ?? 20)}</span>
        </label>
        <label className={`flex items-center gap-2 rounded-lg border px-3 h-10 cursor-pointer text-sm select-none transition-colors ${cena ? "border-sky-300 bg-sky-50 text-sky-800" : "border-slate-200 text-slate-600 hover:bg-slate-50"}`}>
          <Checkbox checked={cena} onCheckedChange={(v) => onCena(!!v)} data-testid={`${testid}-cena-trasferta`} />
          <Moon className="h-4 w-4" /> Cena trasferta <span className="font-mono text-xs opacity-70">{euro(impostazioni?.rimborso_cena_trasferta ?? 20)}</span>
        </label>
      </div>
      <p className="text-xs text-slate-400">Pasto: per ogni dipendente e giorno con ore (si attiva da solo con Luogo = Cantiere). Cena: come le notti, giorni − 1 (l'ultimo giorno è il rientro).</p>
    </div>
  );
}
